import formViewer from './_src/formViewer.vue'
import viewerFormItem from './_src/viewerFormItem.vue'
formViewer.install = function(Vue) {
  Vue.component(formViewer.name, formViewer)
  Vue.component(viewerFormItem.name, viewerFormItem)
}

export default formViewer